import React from 'react';
import PropTypes from 'prop-types';
import { getGtm } from './carouselGA';
import { deepLinkCasino } from '~spa/Utils/WrapperIntegration/Ucf';
import { getIsMobileWrapperFlag } from '~shared/utils/user';

const CasinoCarouselIcon = ({
    iconData,
    children,
    source,
    ...otherProps
}) => {
    const {
        label,
        mobile_game_id: mobileGameId,
        desktop_game_id: desktopGameId,
    } = iconData;

    const handleClick = () => {
        const isMobile = getIsMobileWrapperFlag();
        const gameId = isMobile ? mobileGameId : desktopGameId;
        deepLinkCasino({ id: gameId });
    };

    return (
        <div
            onClick={handleClick}
            data-spectate-product={getGtm(source, label)}
            {...otherProps}>
                {children}
        </div>
    );
};

CasinoCarouselIcon.propTypes = {
    children: PropTypes.node.isRequired,
    iconData: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
};

export default CasinoCarouselIcon;
